// Material
import { styled } from '@mui/material/styles'
import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
} from '@mui/material'
import { useHallInvitationLinks } from '$logic/hall/react-hook'
import { LinkIcon } from '$common/icons/link'
import { openHallInviteLinks } from '$logic/router'
import { toLocale } from '$func/text'
import { t } from '$i18n'

const StyledListItemButton = styled(ListItemButton)`
  height: 50px;
  text-align: inherit;
  box-sizing: border-box;
  padding: 8px 15px;
`

const StyledListItem = styled(ListItem)`
  text-align: inherit;
  padding: 0;
  .MuiTouchRipple-child {
    background-color: #f9f9f9;
  }
`

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 24px;
  margin-left: 15px;
`

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '.MuiTypography-root': {
    ...theme.typography.subtitle3,
  },
}))

const StyledSecondaryListItemText = styled(ListItemText)(({ theme }) => ({
  flex: 'none',
  '.MuiTypography-root': {
    ...theme.typography.subtitle3,
    color: theme.palette.secondary.main,
  },
}))

const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

interface Props {
  hallId: string
}

export function HallInvitationLinksProfileActionItem({ hallId }: Props) {
  const { items, loading } = useHallInvitationLinks(hallId)

  return (
    <>
      <StyledListItem onClick={() => openHallInviteLinks(hallId)}>
        <StyledListItemButton disableGutters>
          <StyledListItemIcon>
            <LinkIcon />
          </StyledListItemIcon>
          <StyledListItemText>
            {t('profile.hall.actions.inviteLinks')}
          </StyledListItemText>

          {loading ? (
            <Skeleton sx={{ minWidth: '25px' }} />
          ) : toLocale(items?.length) ? (
            <StyledSecondaryListItemText>
              {toLocale(items.length)}
            </StyledSecondaryListItemText>
          ) : null}
        </StyledListItemButton>
      </StyledListItem>

      <StyledDivider />
    </>
  )
}
